import jquery from "jquery";
window.$ = window.jQuery = jquery;

import "lazysizes";

import Tab from "bootstrap/js/dist/tab";

Array.from(document.querySelectorAll('#scroll-recruitment'))
    .forEach(ScrollSpyNode => new Tab(ScrollSpyNode))